<template>
  <el-card shadow="false" header="QUERY ID">
    <div class="box">
      {{ detail.queryid }}
    </div>
    <customize-button
      type="primary"
      style="margin-top: 20px"
      @click="handleSubmit"
    >
      Submit
    </customize-button>
  </el-card>
</template>

<script>
import { getBrazilDetail } from '../api'

export default {
  data() {
    return {
      detail: {},
    }
  },
  mounted() {
    this._getBrazilDetail()
  },
  methods: {
    async _getBrazilDetail() {
      try {
        const { id } = this.$store.state.bureauReportBasicInfo
        this.detail = await getBrazilDetail(id)
      } catch (err) {
        console.error(err)
      }
    },
    handleSubmit() {
      if (this.detail.queryid) {
        this.$router.push({
          name: 'bureau-report-add',
          params: { customerId: this.$route.params.customerId },
          query: {
            queryId: this.detail.queryid,
          },
        })
      } else {
        this.$message.warning('Query Id is null')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid #e6e9f4;
  font-size: 14px;
  color: #3a3f63;
  line-height: 20px;
  padding: 16px 20px;
}
</style>
